import React from "react";
import {
    PieChartOutlined,
    LogoutOutlined,
    TeamOutlined,
    SettingOutlined,
    BankOutlined,
    ShoppingOutlined,
    SendOutlined,
    BarChartOutlined,
    BuildOutlined,
    ClockCircleOutlined,
    FundOutlined,
    HeatMapOutlined,
    PushpinOutlined,
    EnvironmentOutlined,
    LineChartOutlined,
    WalletOutlined,
    ShopOutlined,
    SafetyOutlined,
    RadarChartOutlined,
    ScheduleOutlined,
    CreditCardOutlined,
    UsergroupAddOutlined,
    ExclamationCircleOutlined,
    IssuesCloseOutlined,
    FireOutlined,
    TruckOutlined,
    UserSwitchOutlined,
    TruckFilled,
    ToolFilled,
    StarFilled,
    FileTextOutlined,
    DollarCircleOutlined,
    HomeOutlined,
    PlusOutlined,
    DollarCircleFilled,
    WalletFilled,
    AccountBookOutlined,
    TransactionOutlined
} from "@ant-design/icons";
import {CourierIcon} from "../components/_defaultComponents/CourierIcon/CourierIcon";
import i18n from "../i18n";
import {Badge} from "antd";

export const routes = [
    {
        name: () => i18n.t("screens.liveMap", {ns: "common"}),
        icon: <EnvironmentOutlined />,
        path: "/map",
        selectedPath: "/map",
        navPosition: "top",
        "data-testid": "map",
        roles: [
            "admin",
            "superadmin",
            "cUser",
            "hr",
            "operationSupport",
            "oUser",
            "sOperation",
            "data",
            "operationImproving",
            "software",
            "marketing"
        ]
    },
    {
        name: () => i18n.t("screens.orders", {ns: "common"}),
        icon: <ShoppingOutlined />,
        path: "/orders",
        selectedPath: "/orders",
        navPosition: "top",
        "data-testid": "order",
        roles: [
            "admin",
            "superadmin",
            "cUser",
            "operationSupport",
            "oUser",
            "sOperation",
            "data",
            "operationImproving",
            "software",
            "marketing"
        ]
    },
    {
        name: () => "Transferler",
        icon: <TruckOutlined />,
        path: "/transfers",
        selectedPath: "/transfers",
        navPosition: "top",
        "data-testid": "order",
        roles: ["admin", "superadmin", "operationSupport", "oUser"],
        subMenus: [
            {
                name: () => "Dashboard",
                icon: <TruckOutlined />,
                subPath: "/dashboard",
                selectedPath: "/dashboard",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser"]
            },
            {
                name: () => "Transfer Planlama",
                icon: <TruckOutlined />,
                subPath: "/transfers",
                selectedPath: "/transfers",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser"]
            },
            {
                name: () => "Transfer Gruplama",
                icon: <UsergroupAddOutlined />,
                subPath: "/transfer-grouping",
                selectedPath: "/transfer-grouping",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser"]
            },
            {
                name: () => "Aktif Transferler",
                icon: <UsergroupAddOutlined />,
                subPath: "/active-transfers",
                selectedPath: "/active-transfers",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser"]
            },
            {
                name: () => "Transfer Aktiviteleri",
                icon: <UsergroupAddOutlined />,
                subPath: "/transfer-activities",
                selectedPath: "/transfer-activities",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser"]
            },
            {
                name: () => "İade Talepleri",
                icon: <UsergroupAddOutlined />,
                subPath: "/undelivered-shipments",
                selectedPath: "/undelivered-shipments",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser"]
            },
            {
                name: () => "Transfer Merkezleri",
                icon: <HomeOutlined />,
                subPath: "/transfer-center",
                selectedPath: "/transfer-center",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser"]
            },
            {
                name: () => "Yeni Transfer Merkezi",
                icon: <PlusOutlined />,
                subPath: "/new-transfer-center",
                selectedPath: "/new-transfer-center",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser"]
            }
        ]
    },
    {
        name: () => i18n.t("screens.reports", {ns: "common"}),
        icon: <BarChartOutlined />,
        path: "/reports",
        selectedPath: "/reports",
        navPosition: "top",
        "data-testid": "reports",
        roles: ["admin", "superadmin", "cUser", "oUser", "sOperation"],
        subMenus: [
            {
                name: () => i18n.t("screens.generalReports", {ns: "common"}),
                icon: <BarChartOutlined />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                "data-testid": "reports",
                roles: ["admin", "superadmin", "cUser", "oUser", "sOperation"]
            },
            {
                name: () => i18n.t("screens.orderStatisticsReport", {ns: "common"}),
                icon: <BarChartOutlined />,
                subPath: "/order",
                selectedPath: "/order",
                navPosition: "top",
                "data-testid": "reports-orderStatistics",
                roles: ["admin", "superadmin", "cUser", "oUser", "sOperation"]
            },
            {
                name: () => i18n.t("screens.courierStatisticsReport", {ns: "common"}),
                icon: <BarChartOutlined />,
                subPath: "/courierStatistics",
                selectedPath: "/courierStatistics",
                navPosition: "top",
                "data-testid": "reports-courierStatistics",
                roles: ["admin", "superadmin", "cUser", "oUser", "sOperation"]
            },
            {
                name: () => i18n.t("screens.shiftScoreList", {ns: "common"}),
                icon: <ClockCircleOutlined />,
                subPath: "/shift-score",
                selectedPath: "/shift-score",
                navPosition: "top",
                "data-testid": "reports-shiftScore",
                roles: ["admin", "superadmin", "cUser", "oUser", "sOperation"]
            },
            {
                name: () => i18n.t("screens.shiftComplianceReport", {ns: "common"}),
                icon: <BarChartOutlined />,
                subPath: "/shift-compliance",
                selectedPath: "/shift-compliance",
                navPosition: "top",
                "data-testid": "reports-shiftCompliance",
                roles: ["admin", "superadmin", "oUser", "sOperation"]
            }
        ]
    },
    {
        name: () => i18n.t("screens.couriers", {ns: "common"}),
        icon: <CourierIcon />,
        path: "/couriers",
        selectedPath: "/couriers",
        navPosition: "top",
        "data-testid": "couriers",
        roles: [
            "admin",
            "superadmin",
            "finance",
            "hr",
            "hrEmployment",
            "operationSupport",
            "oUser",
            "sOperation",
            "data",
            "operationImproving",
            "software"
        ]
    },
    {
        name: () => i18n.t("screens.availableCouriers", {ns: "common"}),
        icon: <UserSwitchOutlined />,
        path: "/available-couriers",
        selectedPath: "/available-couriers",
        navPosition: "top",
        "data-testid": "available-couriers",
        roles: ["admin", "superadmin", "operationSupport", "oUser", "sOperation"]
    },
    {
        name: () => i18n.t("screens.companies", {ns: "common"}),
        icon: <ShopOutlined />,
        path: "/companies",
        selectedPath: "/companies",
        navPosition: "top",
        "data-testid": "companies",
        roles: [
            "admin",
            "superadmin",
            "finance",
            "data",
            "operationImproving",
            "software",
            "operationSupport",
            "oUser",
            "sOperation"
        ]
    },
    {
        name: () => "Alt Firmalar",
        icon: <ShopOutlined />,
        path: "/subcompanies",
        selectedPath: "/subcompanies",
        navPosition: "top",
        "data-testid": "subcompanies",
        roles: [
            "admin",
            "superadmin",
            "finance",
            "data",
            "operationImproving",
            "software",
            "operationSupport",
            "oUser"
        ]
    },
    {
        name: () => i18n.t("screens.integrators", {ns: "common"}),
        icon: <AccountBookOutlined />,
        path: "/integrators",
        selectedPath: "/integrators",
        navPosition: "top",
        "data-testid": "integrators",
        roles: ["oUser", "admin", "superadmin", "operationSupport", "software"]
    },
    {
        name: () => i18n.t("screens.users", {ns: "common"}),
        icon: <TeamOutlined />,
        path: "/users",
        selectedPath: "/users",
        navPosition: "top",
        "data-testid": "users",
        roles: ["admin", "superadmin", "data", "operationImproving", "software"],
        subMenus: [
            {
                name: () => i18n.t("screens.users", {ns: "common"}),
                icon: <TeamOutlined />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                roles: ["admin", "superadmin", "data", "operationImproving", "software"]
            },
            {
                name: () => i18n.t("screens.authorizationManagement", {ns: "common"}),
                icon: <SafetyOutlined />,
                subPath: "/authorization-management",
                selectedPath: "/authorization-management",
                navPosition: "top",
                roles: ["admin", "superadmin", "data", "operationImproving", "software"]
            }
        ]
    },

    {
        name: () => i18n.t("screens.regionsMap", {ns: "common"}),
        icon: <BuildOutlined />,
        path: "/regions",
        selectedPath: "/regions",
        navPosition: "top",
        "data-testid": "regions",
        roles: ["admin", "superadmin", "operationSupport", "oUser"]
    },
    {
        name: () => i18n.t("screens.poolRegionManagement", {ns: "common"}),
        icon: <RadarChartOutlined />,
        path: "/pools",
        selectedPath: "/pools",
        navPosition: "top",
        "data-testid": "pools",
        roles: ["admin", "superadmin", "operationSupport", "oUser", "sOperation"],
        subMenus: [
            {
                name: () => i18n.t("screens.poolRegionManagement", {ns: "common"}),
                icon: <RadarChartOutlined />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "sOperation"]
            },
            {
                name: () => i18n.t("screens.poolShiftManagement", {ns: "common"}),
                icon: <ClockCircleOutlined />,
                subPath: "/shift-management",
                selectedPath: "/shift-management",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "sOperation"]
            },
            {
                name: () => i18n.t("screens.poolIntensities", {ns: "common"}),
                icon: <FireOutlined />,
                subPath: "/intensities",
                selectedPath: "/intensities",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "sOperation"]
            },
            {
                name: () => i18n.t("screens.poolDailyShifts", {ns: "common"}),
                icon: <ScheduleOutlined />,
                subPath: "/courier-shifts",
                selectedPath: "/courier-shifts",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "sOperation"]
            },
            {
                name: () => i18n.t("screens.poolShiftCancelRequests", {ns: "common"}),
                icon: <IssuesCloseOutlined />,
                subPath: "/shift-cancel-requests",
                selectedPath: "/shift-cancel-requests",
                navPosition: "top",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "sOperation"]
            }
        ]
    },

    {
        name: () => i18n.t("screens.newRequest", {ns: "common"}),
        icon: <SendOutlined />,
        path: "/third-party-request/new",
        selectedPath: "/third-party-request/new",
        navPosition: "top",
        "data-testid": "newRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "oUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})} v2`,
        icon: <SendOutlined />,
        path: "/create-delivery-request",
        selectedPath: "/create-delivery-request",
        navPosition: "top",
        "data-testid": "createDeliveryRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "oUser"]
    },
    {
        name: () => `${i18n.t("screens.shiftRequest", {ns: "common"})}`,
        icon: <ScheduleOutlined />,
        path: "/shift-request",
        selectedPath: "/shift-request",
        navPosition: "top",
        "data-testid": "shiftRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "oUser"],
        subMenus: [
            {
                name: () => `${i18n.t("screens.shiftRequest", {ns: "common"})}`,
                icon: <ScheduleOutlined />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                "data-testid": "shiftRequest",
                roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "oUser"]
            },
            {
                name: () => `${i18n.t("screens.shiftRequestManagement", {ns: "common"})}`,
                icon: <ScheduleOutlined />,
                subPath: "/management",
                selectedPath: "/management",
                navPosition: "top",
                "data-testid": "shiftRequestManagement",
                roles: ["admin", "superadmin", "operationSupport", "software", "oUser"]
            }
        ]
    },
    {
        name: () => `${i18n.t("screens.creditLogs", {ns: "common"})}`,
        icon: <CreditCardOutlined />,
        path: "/credit-logs",
        selectedPath: "/credit-logs",
        navPosition: "top",
        "data-testid": "creditLogs",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "finance"],
        subMenus: [
            {
                name: () => i18n.t("screens.creditLogs", {ns: "common"}),
                icon: <CreditCardOutlined />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                "data-testid": "creditLogs",
                roles: ["admin", "superadmin", "operationSupport", "software", "oUser", "finance"]
            },
            {
                name: () => "Cari Hesaplar",
                icon: <CreditCardOutlined />,
                subPath: "/cari-list",
                selectedPath: "/cari-list",
                navPosition: "top",
                "data-testid": "cari-list",
                roles: ["admin", "superadmin", "operationSupport", "software", "oUser", "finance"]
            },
            {
                name: () => "Cari Detaylar",
                icon: <CreditCardOutlined />,
                subPath: "/cari-list/all",
                selectedPath: "/cari-list/all",
                navPosition: "top",
                "data-testid": "cari-list-all",
                roles: ["admin", "superadmin", "operationSupport", "software", "oUser", "finance"]
            }
        ]
    },
    {
        name: () => "Kapıda Ödeme",
        icon: <DollarCircleOutlined />,
        path: "/cash-on-delivery",
        selectedPath: "/cash-on-delivery",
        navPosition: "top",
        "data-testid": "cash-on-delivery",
        roles: ["admin", "superadmin", "operationSupport", "oUser", "finance"],
        subMenus: [
            {
                name: () => "Özet",
                icon: <UserSwitchOutlined />,
                subPath: "/cash-on-delivery-summary",
                selectedPath: "/cash-on-delivery-summary",
                navPosition: "top",
                "data-testid": "cash-on-delivery-summary",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "finance"]
            },
            {
                name: () => "Kapıda Ödeme",
                icon: <WalletOutlined />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                "data-testid": "cash-on-delivery-main",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "finance"]
            },
            {
                name: () => "Kurye - Terminal Listesi",
                icon: <UserSwitchOutlined />,
                subPath: "/courier-terminals",
                selectedPath: "/courier-terminals",
                navPosition: "top",
                "data-testid": "courier-terminals",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "finance"]
            },
            {
                name: () => "Geçmiş Dönemler",
                icon: <WalletOutlined />,
                subPath: "/past-periods",
                selectedPath: "/past-periods",
                navPosition: "top",
                "data-testid": "past-periods",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "finance"]
            },
            {
                name: () => "Alt Firmalar",
                icon: <WalletOutlined />,
                subPath: "/subCompanies",
                selectedPath: "/subCompanies",
                navPosition: "top",
                "data-testid": "past-periods",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "finance"]
            }
        ]
    },
    {
        name: () => "Cüzdan",
        icon: <WalletOutlined />,
        path: "/wallet",
        selectedPath: "/wallet",
        navPosition: "top",
        "data-testid": "wallet",
        roles: ["admin", "superadmin", "operationSupport", "oUser", "finance"],
        subMenus: [
            {
                name: () => "Kurye Cüzdanları",
                icon: <WalletOutlined />,
                subPath: "/couriers",
                selectedPath: "/couriers",
                navPosition: "top",
                "data-testid": "couriers",
                roles: ["admin", "superadmin", "operationSupport", "oUser", "finance"]
            },
            {
                name: () => "İnaktif Kurye Cüzdanları",
                icon: <WalletOutlined />,
                subPath: "/inactive-couriers",
                selectedPath: "/inactive-couriers",
                navPosition: "top",
                "data-testid": "inactive-couriers",
                roles: ["admin", "superadmin", "operationSupport", "oUser"]
            },
            {
                name: () => "Eklenti/Kesinti",
                icon: <TransactionOutlined />,
                subPath: "/courier-financial-uploads",
                selectedPath: "/courier-financial-uploads",
                navPosition: "top",
                "data-testid": "wallet-courier-financial-uploads",
                roles: ["admin", "superadmin", "operationSupport", "software", "oUser", "finance"]
            }
        ]
    },
    {
        name: () => "Paket İtirazları",
        icon: <ExclamationCircleOutlined />,
        path: "/packet-objection",
        selectedPath: "/packet-objection",
        navPosition: "top",
        "data-testid": "packetObjection",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "oUser"]
    },
    {
        name: () => i18n.t("screens.heatMap", {ns: "common"}),
        icon: <HeatMapOutlined />,
        path: "/heatmap",
        selectedPath: "/heatmap",
        navPosition: "top",
        "data-testid": "heatMap",
        roles: ["admin", "superadmin", "operationSupport", "software"]
    },
    {
        name: () => i18n.t("screens.statistics", {ns: "common"}),
        icon: <FundOutlined />,
        path: "/statistics",
        selectedPath: "/statistics",
        navPosition: "top",
        "data-testid": "statistics",
        roles: [
            "admin",
            "superadmin",
            "operationSupport",
            "software",
            "cUser",
            "oUser",
            "sOperation"
        ]
    },
    {
        name: () => i18n.t("screens.shiftManagement", {ns: "common"}),
        icon: <ClockCircleOutlined />,
        path: "/shift-management",
        selectedPath: "/shift-management",
        navPosition: "top",
        "data-testid": "shiftManagement",
        roles: ["admin", "superadmin", "operationSupport", "software", "oUser", "sOperation"],
        subMenus: [
            {
                name: () => i18n.t("screens.shiftManagement", {ns: "common"}),
                icon: <ClockCircleOutlined />,
                subPath: "/",
                selectedPath: "",
                navPosition: "top",
                "data-testid": "shiftManagement",
                roles: [
                    "admin",
                    "superadmin",
                    "operationSupport",
                    "software",
                    "oUser",
                    "sOperation"
                ]
            },
            {
                name: () => "Vardiya Yönetimi Arşiv",
                icon: <ClockCircleOutlined />,
                subPath: "/snapshot",
                selectedPath: "/snapshot",
                navPosition: "top",
                "data-testid": "snapshot",
                roles: ["admin", "superadmin", "operationSupport", "software", "oUser"]
            },
            {
                name: () => i18n.t("screens.dayOff", {ns: "common"}),
                icon: <ClockCircleOutlined />,
                subPath: "/day-off",
                selectedPath: "/day-off",
                navPosition: "top",
                "data-testid": "day-off",
                roles: ["admin", "superadmin", "operationSupport", "software", "oUser"]
            },
            {
                name: () => i18n.t("screens.quickReactionCouriers", {ns: "common"}),
                icon: <ClockCircleOutlined />,
                subPath: "/quick-reaction-couriers",
                selectedPath: "/quick-reaction-couriers",
                navPosition: "top",
                "data-testid": "quick-reaction-couriers",
                roles: ["admin", "superadmin", "operationSupport", "software", "oUser"]
            }
        ]
    },
    {
        name: () => i18n.t("screens.shiftSuggestion", {ns: "common"}),
        icon: <PushpinOutlined />,
        path: "/shift-suggestion",
        selectedPath: "/shift-suggestion",
        navPosition: "top",
        "data-testid": "shiftSuggestion",
        roles: ["admin", "superadmin", "operationSupport", "software", "oUser", "sOperation"]
    },
    {
        name: () => "Hakediş Yönetimi",
        //name: () => i18n.t("screens.shiftSuggestion", {ns: "common"}),
        icon: <WalletOutlined />,
        path: "/payment-management",
        selectedPath: "/payment-management",
        navPosition: "top",
        "data-testid": "paymentManagement",
        roles: ["admin", "superadmin", "finance"]
    },
    {
        name: () => "Sözleşme Şablon Yönetimi",
        icon: <FileTextOutlined />,
        path: "/contract-management",
        selectedPath: "/contract-management",
        navPosition: "top",
        "data-testid": "contract",
        roles: ["admin", "superadmin", "operationSupport"]
    },
    {
        name: () => i18n.t("screens.appConfig", {ns: "common"}),
        icon: <SettingOutlined />,
        path: "/appconfig",
        selectedPath: "/appconfig",
        navPosition: "bottom",
        "data-testid": "appconfig",
        roles: ["superadmin"]
    }
];

export const customerRoutes = [
    {
        name: () => i18n.t("screens.shiftScoreList", {ns: "common"}),
        icon: <ClockCircleOutlined />,
        path: "/reports/shift-score",
        selectedPath: "/reports/shift-score",
        navPosition: "top",
        "data-testid": "reports-shiftScore",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.myOrders", {ns: "common"}),
        icon: <ShoppingOutlined />,
        path: "/orders",
        selectedPath: "/orders",
        navPosition: "top",
        "data-testid": "order",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.liveMap", {ns: "common"}),
        icon: <EnvironmentOutlined />,
        path: "/map",
        selectedPath: "/map",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.packageStatistics", {ns: "common"}),
        icon: <FundOutlined />,
        path: "/statistics",
        selectedPath: "/statistics",
        navPosition: "top",
        "data-testid": "statistics",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.orderStatisticsReport", {ns: "common"}),
        icon: <BarChartOutlined />,
        path: "/reports/order",
        selectedPath: "/reports/order",
        navPosition: "top",
        "data-testid": "reports-orderStatistics",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.courierStatisticsReport", {ns: "common"}),
        icon: <BarChartOutlined />,
        path: "/reports/courierStatistics",
        selectedPath: "/reports/courierStatistics",
        navPosition: "top",
        "data-testid": "reports-courierStatistics",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.generalReports", {ns: "common"}),
        icon: <LineChartOutlined />,
        path: "/reports",
        selectedPath: "/reports",
        navPosition: "top",
        "data-testid": "reports",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/create-delivery-request",
        selectedPath: "/create-delivery-request",
        navPosition: "top",
        "data-testid": "createDeliveryRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "oUser"]
    },
    {
        name: () => `${i18n.t("screens.shiftRequest", {ns: "common"})}`,
        icon: <ScheduleOutlined />,
        path: "/shift-request",
        selectedPath: "/shift-request",
        navPosition: "top",
        "data-testid": "shiftRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => `${i18n.t("screens.creditLogs", {ns: "common"})}`,
        icon: <CreditCardOutlined />,
        path: "/credit-logs",
        selectedPath: "/credit-logs",
        navPosition: "top",
        "data-testid": "creditLogs",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => i18n.t("screens.payments", {ns: "common"}),
        icon: <WalletOutlined />,
        path: "/payments",
        selectedPath: "/payments",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    }
];

export const nonApiIntegratedCustomerRoutes = [
    {
        name: () => i18n.t("screens.shiftScoreList", {ns: "common"}),
        icon: <ClockCircleOutlined />,
        path: "/reports/shift-score",
        selectedPath: "/reports/shift-score",
        navPosition: "top",
        "data-testid": "reports-shiftScore",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.liveMap", {ns: "common"}),
        icon: <EnvironmentOutlined />,
        path: "/map",
        selectedPath: "/map",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.companyOnboarding", {ns: "common"}),
        icon: <ShopOutlined />,
        path: "/onboardingCompany",
        selectedPath: "/onboardingCompany",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    },
    {
        name: () => i18n.t("screens.payments", {ns: "common"}),
        icon: <WalletOutlined />,
        path: "/payments",
        selectedPath: "/payments",
        navPosition: "top",
        "data-testid": "map",
        roles: ["cUser"]
    }
];

export const poolCustomerRoutes = [
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/create-delivery-request",
        selectedPath: "/create-delivery-request",
        navPosition: "top",
        "data-testid": "createDeliveryRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => i18n.t("screens.statistics", {ns: "common"}),
        icon: <FundOutlined />,
        path: "/statistics",
        selectedPath: "/statistics",
        navPosition: "top",
        "data-testid": "statistics",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "oUser"]
    },
    {
        name: () => i18n.t("screens.myOrders", {ns: "common"}),
        icon: <ShoppingOutlined />,
        path: "/orders",
        selectedPath: "/orders",
        navPosition: "top",
        "data-testid": "order",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.creditLogs", {ns: "common"})}`,
        icon: <CreditCardOutlined />,
        path: "/credit-logs",
        selectedPath: "/credit-logs",
        navPosition: "top",
        "data-testid": "creditLogs",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    }
];

export const poolAndUatCustomerRoutes = [
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri",
        selectedPath: "/musteri",
        navPosition: "top",
        "data-testid": "customerHomePage",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri/siparislerim",
        selectedPath: "/musteri/siparislerim",
        navPosition: "top",
        "data-testid": "customer",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri/muhasebe",
        selectedPath: "/musteri/muhasebe",
        navPosition: "top",
        "data-testid": "customer",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri/manuel-gonderi-olustur",
        selectedPath: "/musteri/manuel-gonderi-olustur",
        navPosition: "top",
        "data-testid": "customer",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri/duyurular",
        selectedPath: "/musteri/duyurular",
        navPosition: "top",
        "data-testid": "customer",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/musteri/hesabim",
        selectedPath: "/musteri/hesabim",
        navPosition: "top",
        "data-testid": "customer",
        roles: ["cUser"]
    },
    {
        name: () => "Kapıda Ödeme", //Müşteri
        icon: <DollarCircleOutlined />,
        path: "/musteri/kapida-odeme",
        selectedPath: "/musteri/kapida-odeme",
        navPosition: "top",
        "data-testid": "cashOnDelivery",
        roles: ["cUser"]
    },
    {
        name: () => "Kapıda Ödemeler - Geçmiş Dönemler", //Müşteri
        icon: <DollarCircleOutlined />,
        path: "/musteri/kapida-odeme/gecmis-donemler",
        selectedPath: "/musteri/kapida-odeme/gecmis-donemler",
        navPosition: "top",
        "data-testid": "cashOnDelivery",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/create-delivery-request",
        selectedPath: "/create-delivery-request",
        navPosition: "top",
        "data-testid": "createDeliveryRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => i18n.t("screens.statistics", {ns: "common"}),
        icon: <FundOutlined />,
        path: "/statistics",
        selectedPath: "/statistics",
        navPosition: "top",
        "data-testid": "statistics",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "oUser"]
    },
    {
        name: () => i18n.t("screens.myOrders", {ns: "common"}),
        icon: <ShoppingOutlined />,
        path: "/orders",
        selectedPath: "/orders",
        navPosition: "top",
        "data-testid": "order",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.creditLogs", {ns: "common"})}`,
        icon: <CreditCardOutlined />,
        path: "/credit-logs",
        selectedPath: "/credit-logs",
        navPosition: "top",
        "data-testid": "creditLogs",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => `${i18n.t("screens.newRequest", {ns: "common"})}`,
        icon: <SendOutlined />,
        path: "/create-delivery-request",
        selectedPath: "/create-delivery-request",
        navPosition: "top",
        "data-testid": "createDeliveryRequest",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    },
    {
        name: () => i18n.t("screens.statistics", {ns: "common"}),
        icon: <FundOutlined />,
        path: "/statistics",
        selectedPath: "/statistics",
        navPosition: "top",
        "data-testid": "statistics",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser", "oUser"]
    },
    {
        name: () => i18n.t("screens.myOrders", {ns: "common"}),
        icon: <ShoppingOutlined />,
        path: "/orders",
        selectedPath: "/orders",
        navPosition: "top",
        "data-testid": "order",
        roles: ["cUser"]
    },
    {
        name: () => `${i18n.t("screens.creditLogs", {ns: "common"})}`,
        icon: <CreditCardOutlined />,
        path: "/credit-logs",
        selectedPath: "/credit-logs",
        navPosition: "top",
        "data-testid": "creditLogs",
        roles: ["admin", "superadmin", "operationSupport", "software", "cUser"]
    }
];
